import { render, staticRenderFns } from "./HealthEducationMonitoring.vue?vue&type=template&id=6647fb31&scoped=true&"
import script from "./HealthEducationMonitoring.vue?vue&type=script&lang=js&"
export * from "./HealthEducationMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./HealthEducationMonitoring.vue?vue&type=style&index=0&id=6647fb31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647fb31",
  null
  
)

export default component.exports